import React, { useEffect, useState } from 'react'
import { Button, Row, Col, Table} from "react-bootstrap"
import { withTranslation } from 'react-i18next';
import { BsFillTrashFill } from 'react-icons/bs';
import Delete from '../../api/Delete';
import { TIPO_DIAGNOSTICO_DELETE } from '../../api/Routes';
import ComponentModalErrorSever from '../ComponentModalErrorSever';
import ModalDiagnosticoColombia from './ModalDiagnosticoColombia';
import {canEditDoctor} from "../../utils/isDoctor";

function DoctorDiagnosticoColombia({ t, notify, citaID, auth, disease, idSpeciality, readOnly, setValidDiagnostico, cita }){
    const [show, setShow] = useState(false);
    const [diagnosticos, setDiagnosticos] = useState(disease)
    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false)

    useEffect(()=>{
        if(diagnosticos.length === 0){
            setValidDiagnostico(false)
        }else{
            setValidDiagnostico(true)
            //console.log(true)
        }
    }, [diagnosticos])

    const deleteDiagnostico = (id) =>{
        Delete({url: `${TIPO_DIAGNOSTICO_DELETE}/${id}`, access_token: auth.data.access_token})
        .then(response=>{
            if(response.data.data.data){
                let arr = diagnosticos.filter(el=>el.id!==id)
                setDiagnosticos(arr)
            }
        })
        .catch(error=>{
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
        })
    }

    return (
        <div className="p-3 pt-4 position-relative">
            <ComponentModalErrorSever 
                show={showModalError}
                handleClose={handleClose}
                error={errorServer}
            />
            <ModalDiagnosticoColombia
                citaID={citaID} 
                show={show}
                setDiagnosticos={setDiagnosticos}
                setShow={setShow}
                idSpeciality={idSpeciality}
                auth={auth}
                setShowModalError={setShowModalError}
                setErrorServer={setErrorServer}
            />
            {!readOnly && canEditDoctor(cita, auth) &&
            <Row className="mt-3">
                <Col>
                    <Button onClick={e=>setShow(true)} variant="outline-primary" size="sm">{t('agregar')} </Button>
                </Col>
            </Row>}
            <Row className="mt-3">
                <Col>
                    <Table size="sm">
                        <thead>
                            <tr>
                                <th>{t('diagnosticos_agregados')}</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                diagnosticos.length === 0 ? 
                                <tr><td>{t('lista_vacia')}</td></tr> :
                                diagnosticos.map((item,i)=>(
                                    <tr key={i}>
                                        <td>{item.diseaseType.name} - {item.disease.code4digits}: {item.disease.description}</td>
                                        {canEditDoctor(cita, auth) &&
                                        <td width="5%">{!readOnly&& <Button type="button" variant="outline-danger" size="sm" className="py-0 px-1"><BsFillTrashFill onClick={e=>deleteDiagnostico(item.id)}/></Button>}</td>
                                        }
                                    </tr>
                                ))
                            }
                        </tbody>
                    </Table>
                </Col>
            </Row>

        </div>
    )
}

export default withTranslation()(DoctorDiagnosticoColombia)